import Vue from 'vue'
import Router from 'vue-router'

// Main Layout
import Layout from '../views/layout/Layout.vue' 

// Route modules
import homeRoutes from './routes/home'
import homeConfigRoutes from './routes/home-config'
import marketplaceRoutes from './routes/marketplace'
import membershipsRoutes from './routes/memberships'
import rewardsnapRoutes from './routes/rewardsnap'
import miscRoutes from './routes/misc'
import editorialRoutes from './routes/editorial'
import couponRoutes from './routes/coupon'
import reportRoutes from './routes/report'
import storeRoutes from './routes/store'
// import benefitRoutes from './routes/benefit'
import notificationRoutes from './routes/notification'
import cpcCampaignRoutes from './routes/cpc-campaign'
import trendingRoutes from './routes/trending'
import dealPostRoutes from './routes/deal-post'
import bannerRoutes from './routes/banner'
import postRoutes from './routes/post'
import shopTheLookRoutes from './routes/shop-the-look'
import promoCodeRoutes from './routes/promo-code'
import productRoutes from './routes/product'
import orderRoutes from './routes/order'
import trendingFeedsRoutes from './routes/trending-feeds'
import brandRoutes from './routes/brand'
import productCatRoutes from './routes/productCat'
import edmRoutes from './routes/edm'
import privateClientRoutes from './routes/private-client'

Vue.use(Router)

/**
  * hidden: true                   if `hidden` is set to true, the item will not show in the sidebar (default is false)
  * alwaysShow: true               if set to true, the route will show up in the root menu, whatever its child routes length
  *                                if not set alwaysShow, only more than one route under the children
  *                                it will becomes nested mode, otherwise not show the root menu
  * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
  * name:'router-name'
  *
  * You can also define your own meta keys.
  * meta : {
      accessibleName: ''              defines the name of the route that will be used to check if a user has access to that route. (required)
      title: 'title'                  defines the name to show in submenu and breadcrumb. (required)
      icon: 'fontawesome-icon-name'   defines the sidebar icon. (optional)
    }
  */

export const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/views/login/index'),
    hidden: true,
  },
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '@/views/error/404'),
    hidden: true,
  },
  {
    path: '/',
    component: Layout,
    redirect: 'dashboard',
    children: [{
      path: 'dashboard',
      component: () => import(/* webpackChunkName: "dashboard" */ '@/views/dashboard/index'),
      name: 'dashboard',
      meta: {
        title: 'dashboard',
        icon: ['fas', 'tachometer-alt'],
      },
    }],
  },
  
  ...homeRoutes,
  ...trendingRoutes,
  ...dealPostRoutes,
  ...bannerRoutes,
  ...edmRoutes,
  ...couponRoutes,
  ...postRoutes,
  ...notificationRoutes,
  ...cpcCampaignRoutes,
  ...miscRoutes,

  ...orderRoutes,
  ...reportRoutes,
  ...rewardsnapRoutes,
  
  ...trendingFeedsRoutes,
  ...membershipsRoutes,
  ...promoCodeRoutes,

  ...productRoutes,
  ...productCatRoutes,

  // ...benefitRoutes,

  ...homeConfigRoutes,
  ...shopTheLookRoutes,
  ...brandRoutes,
  ...marketplaceRoutes,
  ...storeRoutes,
  ...editorialRoutes,
  ...privateClientRoutes,
]

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes,
})
